import { lightTokens } from '../theme/rafayTheme';

// The actual mark: a hexagonal frame around a simplified control-tower
// glyph — replacing the earlier approach of cropping/backing the old wide
// PNG wordmark (control-tower-logo-transparent.png), which didn't match
// what was being asked for here. Built as plain inline SVG shapes (not a
// raster asset) so it stays crisp at any size and can be reused as-is
// outside the theme provider — the app's initial loading splash renders
// before ThemeProvider/ApiProvider even mount, so it can't use makeStyles
// or useTheme, only plain values. Colors are pulled from the same
// `lightTokens` every themed component already shares, just referenced
// directly instead of through the theme object.
export const BrandIcon = ({ size = 40 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <polygon
      points="12,1.2 20.8,6.4 20.8,17.6 12,22.8 3.2,17.6 3.2,6.4"
      fill="#FFFFFF"
      stroke={lightTokens.teal}
      strokeWidth={1.3}
      strokeLinejoin="round"
    />
    <g
      fill="none"
      stroke={lightTokens.textPrimary}
      strokeWidth={1.15}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="4.3" x2="12" y2="6.7" />
      <ellipse cx="12" cy="8.1" rx="3.5" ry="1.5" />
      <path d="M9.9 9 L10.6 17.6" />
      <path d="M14.1 9 L13.4 17.6" />
      <rect x="9.3" y="17.6" width="5.4" height="2" rx="0.3" />
    </g>
  </svg>
);
